// extracted by mini-css-extract-plugin
var _1 = "E6SgBny8LLca0zYf8QJP";
var _2 = "XxbmPHy4oXMrAh35F7L6";
var _3 = "ObBHt2s190cbGM1awGT8";
var _4 = "#000000";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "e13FJnGaxvZdhOOZZhMT";
var _13 = "WlhQlhxvqLaSHlHTqm4S";
var _14 = "GlZfaAFFMeN45cUSVesb";
var _15 = "1200px";
var _16 = "992px";
var _17 = "1366px";
var _18 = "768px";
var _19 = "1475px";
var _1a = "576px";
var _1b = "1600px";
var _1c = "320px";
var _1d = "2500px";
var _1e = "zaGnQsgtEMHgTgQ5RZT0";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "button", _4 as "colorBlack", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "driveItemDetailsFooter", _13 as "reset-button", _14 as "rightGroup", _15 as "screenlg", _16 as "screenmd", _17 as "screenml", _18 as "screensm", _19 as "screenxlg", _1a as "screenxs", _1b as "screenxxlg", _1c as "screenxxs", _1d as "screenxxxlg", _1e as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "button": _3, "colorBlack": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "driveItemDetailsFooter": _12, "reset-button": _13, "rightGroup": _14, "screenlg": _15, "screenmd": _16, "screenml": _17, "screensm": _18, "screenxlg": _19, "screenxs": _1a, "screenxxlg": _1b, "screenxxs": _1c, "screenxxxlg": _1d, "single-page-responsive-font-size": _1e }
